import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css'
import Header from './components/Header';
import Footer from './components/Footer';

import './index.scss';


function App(props) {
  return (
    <div className="app-container">
      <Header/>
      {props.children}
      <Footer/>
    </div>
  );
}

export default App;
